import * as React from "react";
import { Popover, PopoverContent, PopoverTrigger } from "./popover";
import { Button } from "./button";
import { Calendar } from "./calendar";
import dayjs, { Dayjs } from "dayjs";

export interface DatePickerProps {
  value: Dayjs;
  onChange: (date: Dayjs) => void;
  disabled?: boolean;
  className?: string;
  popoverClassName?: string;
}

export const DatePicker: React.FC<DatePickerProps> = ({
  value,
  onChange,
  disabled,
  className,
  popoverClassName,
}) => {
  const [open, setOpen] = React.useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          className={
            className || "w-[180px] justify-start text-left font-normal"
          }
          disabled={disabled}
        >
          {value ? value.format("MMM D, YYYY") : <span>Pick a date</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent
        className={
          popoverClassName ? popoverClassName + " w-auto p-0" : "w-auto p-0"
        }
      >
        <Calendar
          selected={value}
          onSelect={(date: dayjs.Dayjs) => {
            if (date) {
              onChange(date);
              setOpen(false);
            }
          }}
        />
      </PopoverContent>
    </Popover>
  );
};
